module.exports = __webpack_public_path__ + "img/300.64f31510.jpg";